import * as React from 'react';
import {ReactElement} from 'react';
import * as autoBind from 'react-autobind';
import {BasicModal, ControlButton, TextInput} from '@techsmith/tsc-cloud-style-guide';
import Themeable from '../../types/Themeable';
import Constants from '../../globals/Constants';
import Strings from '../../globals/Strings';
import SelfIdentifyBadge from '../../assets/SelfIdentifyBadge.svg';
import InlineInput from '../InlineInput/InlineInput';
import FeedbackUserService from '../../services/FeedbackUserService/FeedbackUserService';

export default class SelfIdentifyModal extends React.Component<SelfIdentifyModalProps, SelfIdentifyModalState> {
   readonly state: SelfIdentifyModalState = {guestName: ''};
   readonly maxLengthError: string = Strings.errors.invalidDisplayNameLength.replace('{param0}', Constants.selfIdentifyName.maxLength + '');

   constructor(props: SelfIdentifyModalProps) {
      super(props);
      autoBind(this);
   }

   onEscape(): void {
      this.setState({guestName: ''});
   }

   onChangeName(e: React.ChangeEvent<HTMLInputElement>): void {
      this.setState({guestName: e.target.value});
   }

   submit(): Promise<void> {
      const {guestName} = this.state;
      if (guestName) {
         return FeedbackUserService.setSelfIdentifiedUser(guestName);
      }
   }

   render(): ReactElement<any> {
      const {guestName} = this.state;
      const {onClose, themeName} = this.props;
      const selfIdentifyStrings = Strings.labels.selfIdentify;
      const inputErrorText = this.state.guestName.length > Constants.selfIdentifyName.maxLength ? this.maxLengthError : '';
      const input = <TextInput placeholder={selfIdentifyStrings.placeholder} errorText={inputErrorText} value={guestName} onChange={this.onChangeName} onEscape={this.onEscape} onEnter={this.submit} themeName={themeName} autoFocus={true} testId="self-identify-input"/>;
      const button = <ControlButton label={selfIdentifyStrings.buttonLabel} disabled={guestName === '' || !!inputErrorText} themeName={themeName} onClick={this.submit} testId="self-identify-submit"/>;
      const {signin: signinUrl, tos: tosUrl} = Constants.siteLinks;

      return (
         <BasicModal themeName={themeName} width="26rem" onClose={onClose} headerVisible={false} testId="self-identify" zIndex={13}>
            <div className="self-identify">
               <SelfIdentifyBadge />
               <div className="title">{selfIdentifyStrings.badgeText}</div>
               <div className="tos">{selfIdentifyStrings.tos} <a href={tosUrl} target="_blank">{selfIdentifyStrings.tosLink}</a></div>
               <InlineInput middleComponent={input} rightComponent={button} />
               <div className="signin">{selfIdentifyStrings.signin} <a href={signinUrl}>{selfIdentifyStrings.signinLink}</a></div>
            </div>
         </BasicModal>
      );
   }
}

export interface SelfIdentifyModalProps extends Themeable {
   onClose(): void;
}

export interface SelfIdentifyModalState {
   guestName: string;
}
